export default "__VITE_ASSET__9Cj5AhmO__"